import { Dialog, Transition } from "@headlessui/react";
import React, { FC, Fragment, useEffect, useState, useMemo, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import Select from 'react-select';
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import axios from "axios";
import withRouter from "components/Common/withRouter";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import { useFormik } from "formik";
import { RootState } from 'store/reducers';
import { isImageJpgOrPng, isImageSizeValid, callMultipartFormDataApi, isSheet, isImageJpgOrPngOrPdf, presignedUrl, uploadFileToS3 } from "components/Common/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "containers/Admin/Loader";
import {
    clearData,
    getList as onGetList,
    getData as onGetData,
    updateData as onUpdateData,
    addNewData as onAddNewData,
} from "store/AppMaster/actions";
import api from "constants/api";
import {
    Typography,
    Button,
    Avatar,
} from "@material-tailwind/react";


import noImageFound from '../../../images/No_Image_Available.jpg'
export interface EditProps {
    show: boolean;
    onCloseModalQuickView: () => void;
    optionCategory: any[];
}

const Edit: FC<EditProps> = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const initialRender = useRef(true);
    const location = useLocation();
    const dispatch = useDispatch();
    const [isApiCall, setIsApiCall] = useState(0)
    const [optionListData, setOptionListData] = useState(false);
    const [groupData, setGroupData] = useState<Boolean>(false);
    const [optionCategory, setOptionCategory] = useState<any[]>([]);
    const [selectedData, setSelectedData] = useState([]);
    const [loderImage, setLoader] = useState(false);

    const [frmData, setFrmData] = useState({
        id: "",
        name: "",
        per_weight_charge: "",
        status: "",
    });

    const onChangeHandler = (event: any) => {
        const { name, value } = event.target;
        setFrmData((preValue) => {
            return {
                ...preValue,
                [name]: value,
            };
        });
    }

    const statusOptions = [
        { key: 'Active', value: 'Active' },
        { key: 'Inactive', value: 'Inactive' },
    ];

    useEffect(() => {
        if (isApiCall === 0) {
            getGroupDetails();
            setIsApiCall(1);
        }
        initialRender.current = false;

        if (groupData == true && optionCategory.length === 0) {
            setOptionListData(true);
        }
    }, [isApiCall, groupData, optionCategory]);

    const { data } = useSelector((state: RootState) => state.AppMaster);


    const getGroupDetails = () => {
        setGroupData(true);
        //dispatch(clearData())
        let filterData = {
            id: params.id
        }
        dispatch(onGetData(filterData, '', api.getDeliveryPartnerDetail));
    }


    if (data != null && groupData == true) {
        if (data.result != null) {
            setGroupData(false);
             console.log(data.result, "divy");

            setFrmData((preValue) => {
                return {
                    ...preValue,
                    id: data.result._id,
                    name: data.result.name,
                    per_weight_charge: data.result.per_weight_charge,
                    status: data.result.status,
                };
            });
        }
    }
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed


        enableReinitialize: true,
        initialValues: {
            id: frmData.id,
            name: frmData.name,
            per_weight_charge: frmData.per_weight_charge,
            status: frmData.status,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
            per_weight_charge: Yup.string().required("Price is required"),
            status: Yup.string().required("Status is required"),
        }),
        onSubmit: async (values) => {
            const newData = {
                id: frmData.id,
                name: values.name,
                per_weight_charge: values.per_weight_charge,
                status: values.status,
            };
            dispatch(onUpdateData(newData, '', api.updateDeliveryPartner));
            // setSubmitted(true);
            setTimeout(() => {
                navigate('/admin/delivery-partner');
            }, 1500);
        },
    });


    return (
        <div className="container py-16 lg:pb-28 lg:pt-20">
            <Helmet>
                <title>Edit Delivery Partner</title>
            </Helmet>
            <Loader
                loderImage={loderImage}
            />
            <div className="mb-12 sm:mb-16">
                <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold ">Edit Delivery Partner</h2>
            </div>
            <div className="mt-8 sm:mt-10">
                <div className="flex-1  rounded-xl hiddenScrollbar">
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                        method="post">
                        <div className="p-4">
                            <div className="mb-4">
                                <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Enter the Name of the Delivery Partner
                                </label>
                                <input
                                    id="name"
                                    name="name"
                                    placeholder="Name"
                                    type="text"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    value={frmData.name}
                                    onChange={onChangeHandler}
                                />
                                {validation.errors.name ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.name}
                                    </div>
                                ) : null}
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="per_weight_charge"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Enter the Price per Weight
                                </label>
                                <input
                                    id="per_weight_charge"
                                    name="per_weight_charge"
                                    value={frmData.per_weight_charge}
                                    placeholder="Price"
                                    type="text"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    onChange={onChangeHandler}
                                />
                                {validation.errors.per_weight_charge ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.per_weight_charge}
                                    </div>
                                ) : null}
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="status"
                                    className="block text-sm font-medium text-gray-700"
                                >
                                    Select Status
                                </label>
                                <select
                                    id="status"
                                    name="status"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    value={frmData.status}
                                    onChange={onChangeHandler}
                                >
                                    <option value="">Select Status</option>
                                    {statusOptions.map(option => (
                                        <option key={option.key} value={option.key}>
                                            {option.value}
                                        </option>
                                    ))}
                                </select>
                                {validation.errors.status ? (
                                    <div className="text-red-500 text-sm mt-1">
                                        {validation.errors.status}
                                    </div>
                                ) : null}
                            </div>

                            <div className="text-center mt-3">
                                <ButtonPrimary type="submit">
                                    <span>Submit</span>
                                </ButtonPrimary>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default withRouter(Edit);
